import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Back from "../../components/goBack";
import Entry from "./viewEntry";

class ViewTaxPayer extends Component {
  state = {
    info: ""
  };

  componentDidMount() {
    this.getTpInfo(JSON.parse(localStorage.MobileBntinId));
  }

  updateTaxpayerHandler = () => {
    this.props.history.push("/updateTp");
  };

  certHandler = () => {
    this.props.history.push("/cert");
  };

  getTpInfo = data => {
    this.setState({ info: data });
  };

  goBack = () => {
    this.props.history.push("/view");
  };

  render() {
    return (
      <div style={styles.container}>
        {/* <ScrollView> */}
        <Back clickHandler={this.goBack} />
        <Entry heading="TIN:" value={this.state.info.TIN} />
        <Entry heading="TITLE:" value={this.state.info.indv_title} />
        <Entry heading="SURNAME:" value={this.state.info.surname} />
        <Entry heading="FIRST NAME:" value={this.state.info.first_name} />
        <Entry heading="MIDDLE NAME:" value={this.state.info.middle_name} />
        <Entry heading="BIRTH DATE:" value={this.state.info.birth_date} />
        <Entry heading="EMAIL:" value={this.state.info.email} />
        <Entry heading="PHONE NUMBER:" value={this.state.info.phone_number} />
        <Entry heading="STATE:" value={this.state.info.state_of_residence} />
        <Entry heading="CITY:" value={this.state.info.city} />
        <Entry heading="LGA:" value={this.state.info.lga} />
        <Entry heading="TAX OFFICE:" value={this.state.info.tax_office} />
        <Entry heading="WARD:" value={this.state.info.ward} />
        {/* </ScrollView> */}

        <div style={styles.btnDiv}>
          <button style={styles.update} onClick={this.updateTaxpayerHandler}>
            UPDATE
          </button>
          <button style={styles.cert} onClick={this.certHandler}>
            Generate Certificate
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(ViewTaxPayer);

const styles = {
  container: {
    width: "100%",
    height: "100%",
    top: " 0px",
    left: "0px",
    backgroundColor: "white",
    position: "absolute"
  },
  btnDiv: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    fontSize: "1.5em",
    marginTop: "20px"
  },
  update: {
    backgroundColor: "#521751",
    color: "#fff",
    border: "none",
    width: "30%",
    height: "30px"
  },
  cert: {
    backgroundColor: "red",
    color: "#fff",
    border: "none",
    width: "30%",
    height: "30px"
  }
};
